<script setup lang="ts">
import { ref, watch } from 'vue'

import { SuccessBadge, TextInput } from '@collector/shared-ui'
import { Incident } from '@collector/sportsapi-client'
import { useEventIncidentsQueue } from '@desktop/views/Relation/Sports/composables'

interface Props {
  incident: Incident
  displayInfo: string
  disabled: boolean
}

const props = defineProps<Props>()

// composables
const eventIncidentsQueue = useEventIncidentsQueue()

// state
const value = ref(props.incident.display_info)
const successBadge = ref<InstanceType<typeof SuccessBadge> | null>(null)

function updateValue(newValue: string | null): void {
  if (newValue !== value.value) {
    value.value = newValue

    eventIncidentsQueue.updateIncident(
      { display_info: newValue },
      props.incident,
    )
  }
}

// init
watch(
  () => props.incident.display_info,
  (newVal) => {
    if (newVal === value.value) {
      successBadge.value?.show()
    }
  },
)
</script>

<template>
  <TextInput
    class="relative gap-x-2"
    :modelValue="value"
    :maxlength="2"
    width="full"
    inputClass="px-1"
    :disabled
    numeric
    @blur="({ value }) => updateValue(value === '' ? null : value)"
  >
    <span class="min-w-13">
      {{ displayInfo }}
    </span>
    <template #content>
      <SuccessBadge
        ref="successBadge"
        class="absolute top-1/2 right-1 -translate-y-1/2"
      />
    </template>
  </TextInput>
</template>
